import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="final-cta" className="py-12 md:py-24 px-4 bg-warm-900 text-cream relative overflow-hidden" data-id="element-16">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-sage/10 blur-[100px] rounded-full pointer-events-none" data-id="element-17" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-18">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 leading-tight" data-id="element-19">
          La cena resuelta. <br data-id="element-20" />
          <span className="italic text-sage-light font-normal" data-id="element-21">
            La mente tranquila.
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-base md:text-xl text-cream/75 mb-8 md:mb-10 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-22">
          Empieza esta noche a quitarte la pregunta más pesada del día.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} data-id="element-23">
          <motion.a href="https://vidaconmetodo.com/cart/44482692808819:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-2 bg-sage-light text-warm-900 hover:bg-cream font-semibold py-5 px-10 rounded-full text-lg md:text-xl transition-colors duration-300" data-id="element-24">
            Quiero la cena resuelta hoy mismo
            <ArrowRightIcon className="w-5 h-5" data-id="element-25" />
          </motion.a>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="mt-8 flex items-baseline justify-center gap-2" data-id="element-26">
            <span className="text-3xl md:text-4xl font-bold text-sage-light font-heading tracking-tight" data-id="element-27">
              $27
            </span>
            <span className="text-base text-cream/60 font-medium" data-id="element-28">
              USD · Un solo pago
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}